/**
 * @returns {QiyehuoAdmin | undefined}
 */
export function getQiyehuoAdmin() {
  return window.QiyehuoAdmin;
}

/**
 *
 * @param {(QiyehuoAdmin)=>void} callback
 */
export function runQiyehuoAdmin(callback, options = {}) {
  if (window.QiyehuoAdmin) {
    callback(window.QiyehuoAdmin);
  } else {
    console.warn('QiyehuoAdmin not ready');
  }
}

/**
 * @typedef {Object} process
 */

const isDev = process.env.NODE_ENV === 'development';

export function loadQiyehuoAdmin() {
  if (window.QiyehuoAdmin) {
    console.warn('QiyehuoAdmin already loaded');
    return Promise.resolve(window.QiyehuoAdmin);
  }
  let src = 'https://6.qiyehuo.com/libs/qiyehuo.admin.js';
  if (isDev) {
    console.debug('loadQiyehuoAdmin in dev mode');
    src = 'http://127.0.0.1:3000/libs/qiyehuo.admin.js';
  }
  // 方便调试
  src = sessionStorage.getItem('QiyehuoAdmin.src') || src;
  loadScript(src).then(() => {
    console.debug('QiyehuoAdmin: ready');
  }).catch(e => {
    console.error(`QiyehuoAdmin: failed`, e);
  });
}

loadQiyehuoAdmin();

/**
 * @typedef {Object} QiyehuoAdmin
 * @property {({orderId:string})=>void} showCompanyRegistryFlow
 * @property {function} getTrpcClient
 * @property {function} setup
 */

function loadScript(src, options) {
  const $ele = document.querySelector(`script[src="${src}"]`);
  if ($ele) {
    return Promise.resolve($ele);
  }
  return new Promise((resolve, reject) => {
    const el = document.createElement('script');
    el.src = src;

    el.onload = () => {
      resolve(el);
    };
    el.onerror = (e) => {
      el.remove();
      reject(e);
    };

    const { attributes = {} } = options || {};
    Object.entries(attributes).forEach(([k, v]) => {
      el.setAttribute(k, v);
    });

    document.head.appendChild(el);
  });
}



// WEBPACK FOOTER //
// ./src/lib/QiyehuoAdmin.js